import { render, staticRenderFns } from "./FormError.vue?vue&type=template&id=23b88f20"
import script from "./FormError.vue?vue&type=script&lang=ts"
export * from "./FormError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23b88f20')) {
      api.createRecord('23b88f20', component.options)
    } else {
      api.reload('23b88f20', component.options)
    }
    module.hot.accept("./FormError.vue?vue&type=template&id=23b88f20", function () {
      api.rerender('23b88f20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/FormError.vue"
export default component.exports